import type { AlertProps, AlertStatus, InsightProps } from "./insights";

export const getAlertStatus = (alert?: AlertProps | null): AlertStatus => {
  if (!alert) return "unset";
  if (
    alert.is_archived === false &&
    alert.condition_is_valid === true &&
    alert.condition_is_met === true
  ) {
    return "alerted";
  }
  if (
    alert.is_archived === false &&
    alert.condition_is_valid === true &&
    alert.condition_is_met === false
  ) {
    return "monitored";
  }
  if (alert.is_archived) {
    return "archived";
  }
  return "unset";
};

export const isAlerted = (alert?: AlertProps | null) =>
  getAlertStatus(alert) === "alerted";

export const isMonitored = (alert?: AlertProps | null) =>
  getAlertStatus(alert) === "monitored";

export const isArchived = (alert?: AlertProps | null) =>
  getAlertStatus(alert) === "archived";

export const isUnset = (alert?: AlertProps | null) =>
  getAlertStatus(alert) === "unset";

export const isInsightArchived = (insight?: InsightProps | null) =>
  insight?.is_archived === true;

export const getAlertDisplayTitle = (alert?: AlertProps | null) =>
  alert?.title || "Not available";

export const getAlertDisplayCondition = (alert?: AlertProps | null) =>
  alert?.condition || "Not available";
